import { jsx as r } from "react/jsx-runtime";
import o from "../../Icons/Spinner.js";
import { LoadingIndicatorWrapper as i } from "../styled.js";
const d = () => /* @__PURE__ */ r(i, { children: /* @__PURE__ */ r(o, { height: 22, width: 22, duration: "0.5s" }) });
export {
  d as default
};
